import { LicenseName } from "@/data/license.data";

export abstract class DownloadResultLimiter {
  abstract isDownloadEnabled(license: LicenseName);
}
